import addEmptyBlocks, { addEmptyBlocksCreators } from "../../utils/addEmptyBlocks";
import { NftCard } from "../Products/NftCard/NftCard";
import { CollectionCard } from "../Products/CollectionCard/CollectionCard";
import { CreatorCard } from "../CreatorCard/CreatorCard";
import { MarketplaceButton, ProductsGridMain, ProductsGridWrapper } from "./ProductsGrid.styled";
import { useNavigate } from "react-router-dom";

export const ProductsGrid = ({ products, collection = false, creators = false, title, showButton = false }) => {
  const navigate = useNavigate();
  return (
    <ProductsGridWrapper>
      {title && <h4>{title}</h4>}
      <div className='container'>
        <ProductsGridMain>
          {products.map((product, i) =>
            collection ? (
              <CollectionCard product={product} key={i} />
            ) : creators ? (
              <CreatorCard creator={product} number={i} key={i} />
            ) : (
              <NftCard product={product} key={i} />
            )
          )}
          {creators ? addEmptyBlocksCreators(products.length) : addEmptyBlocks(products.length)}
        </ProductsGridMain>
        {showButton && <MarketplaceButton onClick={() => navigate("/marketplace/nfts")}>Go to Mаrketplаce</MarketplaceButton>}
      </div>
    </ProductsGridWrapper>
  );
};
